import { DateTimeUtils, TimestampFilters } from 'dyl-components';
import CalendarToolBar from 'pages/Calendar/subcomponents/CalendarToolBar';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Grid, Segment, Header, Icon } from "semantic-ui-react";
import { getData, onToggleTimeUnit, useRangeCalendar } from 'shared/CustomDateRange/customDateRange';
import { GetTimezone } from 'utils/TZDisplay';
import UsageStatsTextsTable from './Table/page';
import { useDispatch, useSelector } from 'react-redux';
import { MathUtils, StringUtils } from 'utils';
import paymentActions from 'actions/payment';
import textActions from 'actions/text';
import "./index.scss"
const UsageStatsText = () => {
    const [params] = useSearchParams();
    const calendarRef = useRef(null);

    const dispatch = useDispatch()
    const isCustomeDateSelected = params.get("start")?.length > 0
    const startParams = params.get("start");
    const endParams = params.get("end");
    const paramDateRange = `${startParams ? DateTimeUtils.formatEpoch(startParams, DateTimeUtils.DATE_FORMAT) : ""} - ${endParams ? DateTimeUtils.formatEpoch(endParams, DateTimeUtils.DATE_FORMAT) : ""}`;
    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);
    const navigate = useNavigate()
    const [timeUnits, setTimeUnits] = useState("week");
    const [offset, setOffset] = useState(0);
    const [viewType, setViewType] = useState("list");
    const [calendarDate, setCalendarDate] = useState(
        DateTimeUtils.getUnixTime(
            DateTimeUtils.getCurrentDate(),
            DateTimeUtils.DATE_FORMAT,
            GetTimezone()
        )
    );
    const refreshCalendarDate = () => {
        const date = fullCalendarApiFunction("getDate");
        const unixDate = DateTimeUtils.getUnixTime(
            `${date.getUTCMonth() + 1
            }-${date.getUTCDate()}-${date.getUTCFullYear()}`,
            DateTimeUtils.DATE_FORMAT
        );
        setCalendarDate(unixDate);
    };
    const fullCalendarApiFunction = (name, params = []) => {
        const api = calendarRef.current.getApi();
        return api[name](...params);
    };

    const changeCalendarView = (option) => {
        const views = {
            day: "timeGridDay",
            week: "timeGridWeek",
            month: "dayGridMonth",
            year: "multiMonthYear",
        };
        fullCalendarApiFunction("changeView", [views[option]]);
    };
    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };
    const balanceInfo = useSelector(state => (state.payment.balanceInfo));
    const isRetrievingBalance = useSelector(state => (state.payment.isRetrievingBalance));
    const customer_id = useSelector(state => state.auth.customer_id);
    const startTime = DateTimeUtils.getStartOf(calendarDate, timeUnits);
    const endTime = DateTimeUtils.getEndOf(calendarDate, timeUnits);

    useEffect(() => {
        dispatch(paymentActions.getBalance(customer_id, { isAdmin: true }));
    }, [dispatch, customer_id])
    
    useEffect(()=>{
        dispatch(textActions.getUsers())
        dispatch(textActions.getPhones({ noFilter: true }));
        dispatch(textActions.getContactPhones({ filter: true }));
    },[dispatch])

    useEffect(()=>{
        const contact_phone = params.get("contact_phone")?.split(",");
        const customer_phone = params.get("customer_phone")?.split(",");
        const order = params.get("order");
        const user_id = params.get("user_id")?.split(",");
        const page = params.get("page") || 1

        const LIMIT = 25;
        dispatch(textActions.getLogs({
            customer_id,
            start: startTime,
            end: endTime,
            limit: LIMIT,
            offset: (page - 1) * LIMIT,
            contact_phone: contact_phone?.length ? contact_phone : undefined,
            customer_phone: customer_phone?.length ? customer_phone : undefined,
            order: order || undefined,
            user_id: user_id?.length ? user_id : undefined
        }));
    
    },[params, dispatch, customer_id, startTime, endTime])
    const { billableTextMessageCount = 0, isReadingLogs} = useSelector(state => state.text);

    return (
        <Grid style={{ padding: '20px' }}>
            <Grid.Row>
                <Grid.Column width={3}>
                    <Segment loading={isReadingLogs}>
                        <Header color="primary">Total Billable</Header>
                        <Header as='h4'>{billableTextMessageCount} Messages</Header>
                    </Segment>
                </Grid.Column>
                <Grid.Column width={7} />
                <Grid.Column width={3}>
                    <Segment loading={isRetrievingBalance}>
                        <Header color="primary">SMS Reload Balance</Header>
                        <Header {...(balanceInfo.sms_balance < 0 ? { className: 'Balance--negative' } : {})} as="h4">${StringUtils.formatDecimal(`${MathUtils.roundDecimals(balanceInfo.sms_balance)}`, true)}</Header>
                    </Segment>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row verticalAlign='middle'>
                <Grid.Column width={11}>
                    <span className="UsageStatesTexts__Header">
                        <Icon size="large" className="fas fa-calendar-plus" color="blue" onClick={() => setCustomDateRangeOpen(true)} link />
                        <CalendarToolBar
                            timeUnits={timeUnits}
                            setTimeUnits={setTimeUnits}
                            offset={offset}
                            setOffset={setOffset}
                            viewType={viewType}
                            setViewType={setViewType}
                            refreshCalendarDate={refreshCalendarDate}
                            fullCalendarApiFunction={fullCalendarApiFunction}
                            calendarDate={calendarDate}
                            setCalendarDate={setCalendarDate}
                            changeCalendarView={changeCalendarView}
                            removeRightIcons
                            isDropDownDisable={isCustomeDateSelected}
                            customeTitleComponent={
                                isCustomeDateSelected ? <React.Fragment>
                                    <Header as={'h3'} className="CalendarToolbar__Header">
                                        {paramDateRange}
                                        <Icon link className='fa-solid fa-times' onClick={() => {
                                            setDateRange(" - ");
                                            navigate("/settings/usage-stats/texts")
                                        }} />
                                    </Header>
                                </React.Fragment> : undefined
                            }
                            isForceEnableRighButton={isCustomeDateSelected}
                        />
                    </span>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={13}>
                    <UsageStatsTextsTable />
                </Grid.Column>
            </Grid.Row>
            <TimestampFilters
                title={"Select Date"}
                timestamp={timestamp}
                onToggleTimeUnit={(timestamp) =>
                    onToggleTimeUnit(
                        timestamp,
                        setTimestamp,
                        params,
                        navigate,
                        ""
                    )
                }
                isCustomDateRangeOpen={isCustomDateRangeOpen}
                onOpenCustomDateRange={() => {
                    setCustomDateRangeOpen(true);
                    setDateRange('');
                }}
                onCloseCustomDateRange={() => {
                    setCustomDateRangeOpen(false);
                }}
                dateRange={dateRange}
                onDateRangeChange={onDateRangeChange}
                getData={() =>
                    getData({
                        setCustomDateRangeOpen,
                        dateRange,
                        userAuthTimezone,
                        params,
                        navigate,
                        url: "",
                    })
                }
                noTrigger
            />
        </Grid>
    );
}

export default UsageStatsText;
